import { preprocess } from '@artica/assets';
import formatSpiral from '../../common/formatSpiral';

preprocess('spiral_dyson', function preprocessDysonSpiral(asset) {
  return formatSpiral(asset, {
    lineOpacity: 0.1,
  });
});